import React from 'react'
import { FaInstagram, FaTwitter, FaFacebookF, FaWhatsapp, FaTiktok, FaPhone, FaMailchimp } from 'react-icons/fa'

function Footer() {
  return (
    <footer>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "2rem",
          marginBottom: "2rem",
        }}
      >
        {/* Sección Logo y Descripción */}
        <div style={{ textAlign: "center" }}>
          <h3
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "2rem",
              background: "var(--gradient-soft)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginBottom: "1rem",
            }}
          >
            La CLO Brand
          </h3>
          <p
            style={{
              color: "var(--slate-200)",
              fontSize: "1rem",
              lineHeight: "1.6",
              maxWidth: "300px",
              margin: "0 auto",
            }}
          >
            Donde la moda se encuentra con la elegancia. Creando experiencias
            únicas que trascienden lo ordinario y abrazan lo extraordinario.
          </p>
        </div>

        {/* Sección Enlaces Rápidos */}
        <div style={{ textAlign: "center" }}>
          <h4
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "1.3rem",
              color: "var(--accent-teal)",
              marginBottom: "1rem",
            }}
          >
            Enlaces Rápidos
          </h4>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            <a
              href="/"
              style={{
                color: "var(--slate-200)",
                textDecoration: "none",
                transition: "all 0.3s ease",
                fontFamily: "var(--font-body)",
              }}
            >
              🏠 Inicio
            </a>
            <a
              href="/Productos"
              style={{
                color: "var(--slate-200)",
                textDecoration: "none",
                transition: "all 0.3s ease",
                fontFamily: "var(--font-body)",
              }}
            >
              👗 Colección
            </a>
            <a
              href="/Contacto"
              style={{
                color: "var(--slate-200)",
                textDecoration: "none",
                transition: "all 0.3s ease",
                fontFamily: "var(--font-body)",
              }}
            >
              <FaMailchimp
                style={{ marginRight: "0.5rem", color: "var(--accent-rose)" }}
              />
              Contacto
            </a>
          </div>
        </div>

        {/* Sección Redes Sociales */}
        <div style={{ textAlign: "center" }}>
          <h4
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "1.3rem",
              color: "var(--accent-teal)",
              marginBottom: "1rem",
            }}
          >
            Síguenos
          </h4>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1.5rem",
              fontSize: "1.8rem",
            }}
          >
            <a
              href="https://instagram.com/laclobrand"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#E4405F",
                textDecoration: "none",
                transition: "all 0.3s ease",
                transform: "scale(1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
                borderRadius: "12px",
                background: "rgba(228, 64, 95, 0.1)",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "scale(1.2)";
                e.target.style.background = "rgba(228, 64, 95, 0.2)";
                e.target.style.boxShadow = "0 0 20px rgba(228, 64, 95, 0.4)";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.background = "rgba(228, 64, 95, 0.1)";
                e.target.style.boxShadow = "none";
              }}
            >
              <FaInstagram />
            </a>

            <a
              href="https://twitter.com/laclobrand"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1DA1F2",
                textDecoration: "none",
                transition: "all 0.3s ease",
                transform: "scale(1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
                borderRadius: "12px",
                background: "rgba(29, 161, 242, 0.1)",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "scale(1.2)";
                e.target.style.background = "rgba(29, 161, 242, 0.2)";
                e.target.style.boxShadow = "0 0 20px rgba(29, 161, 242, 0.4)";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.background = "rgba(29, 161, 242, 0.1)";
                e.target.style.boxShadow = "none";
              }}
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.instagram.com/laclobrand/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#4267B2",
                textDecoration: "none",
                transition: "all 0.3s ease",
                transform: "scale(1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
                borderRadius: "12px",
                background: "rgba(66, 103, 178, 0.1)",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "scale(1.2)";
                e.target.style.background = "rgba(66, 103, 178, 0.2)";
                e.target.style.boxShadow = "0 0 20px rgba(66, 103, 178, 0.4)";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.background = "rgba(66, 103, 178, 0.1)";
                e.target.style.boxShadow = "none";
              }}
            >
              <FaFacebookF />
            </a>           

            <a
              href="https://tiktok.com/@laclobrand"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#FF0050",
                textDecoration: "none",
                transition: "all 0.3s ease",
                transform: "scale(1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
                borderRadius: "12px",
                background: "rgba(255, 0, 80, 0.1)",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "scale(1.2)";
                e.target.style.background = "rgba(255, 0, 80, 0.2)";
                e.target.style.boxShadow = "0 0 20px rgba(255, 0, 80, 0.4)";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.background = "rgba(255, 0, 80, 0.1)";
                e.target.style.boxShadow = "none";
              }}
            >
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>

      {/* Línea divisoria */}
      <div
        style={{
          height: "1px",
          background: "var(--gradient-soft)",
          margin: "2rem 0 1rem 0",
        }}
      ></div>

      {/* Copyright */}
      <div style={{ textAlign: "center" }}>
        <p
          style={{
            fontFamily: "var(--font-body)",
            fontSize: "1rem",
            color: "var(--slate-200)",
            margin: "0",
          }}
        >
          © 2025 La CLO Brand - Todos los derechos reservados - Desarrollo Web by{" "}
          <a
            href="https://www.linkedin.com/in/marisa-viotti-74601036a/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0077b5", textDecoration: "none" }}
          >
            Marisa Viotti
          </a>
        </p>
        <p
          style={{
            fontSize: "0.9rem",
            color: "var(--slate-400)",
            marginTop: "0.5rem",
            fontStyle: "italic",
          }}
        >
          Diseñado con elegancia y tecnología ✨
        </p>
      </div>
    </footer>
  );
}

export default Footer